<script setup lang="ts">
    import { http } from '@/shared/httpWrapper.js';
    import { importShippingPackage } from '@/shared/helpers/api';
    import { useShippingStore } from '@/stores/shippingStore';
    import useShow from '@/shared/composables/useShow';

    const store = useShippingStore();
    const { showInfo } = useShow();

    async function onRunImport(): Promise<void> {
        await importShippingPackage(http, store.selectedPackage!.packageId);
        showInfo('Import started..');
        await store.refresh();
    }
</script>

<template>
    <template v-if="store.selectedPackage!.status === 'ReadyForImport'">
        <template v-if="store.showChanges">
            <div class="block">
                <div class="shipping-section-header block">
                    Instructions
                </div>
                <div class="is-size-5">
                    Importing this package will apply the changes listed below.
                    Any changes listed as not authorized will be skipped, which may not be what you want.
                    To authorize these changes, the package must be uploaded by a user with enough privileges to perform the changes.
                </div>
            </div>
            <div
                class="is-flex is-justify-content-center pt-5 pb-5">
                <b-button
                    type="is-primary"
                    size="is-large"
                    outlined
                    @click="onRunImport">
                    Run import
                </b-button>
            </div>
        </template>
        <div
            v-else
            class="block">
            <div class="shipping-section-header block">
                No changes
            </div>
            <div class="is-size-5">
                Analysing the uploaded package we found no changes to apply - the state in this Common Library database
                already agrees with the data from the package.
            </div>
        </div>
    </template>
</template>
